import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/components/providers/AuthProvider";
import { useEffect } from "react";
import { LoginCard } from "@/components/auth/LoginCard";

interface LoginSearch {
  redirect?: string | undefined;
  error?: string | undefined;
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: typeof search.redirect === "string" ? search.redirect : undefined,
      error: typeof search.error === "string" ? search.error : undefined,
    };
  },
  component: LoginPage,
});

function LoginPage() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const { redirect: redirectPath, error } = Route.useSearch();

  // Redirect to clubs if already logged in
  useEffect(() => {
    if (!isLoading && user) {
      navigate({ to: redirectPath || "/clubs" });
    }
  }, [user, isLoading, navigate, redirectPath]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-accent-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Simplified header with wordmark */}
      <header className="py-3 px-6">
        <a href="https://tiny.club">
          <img
            src="/images/wordmark.png"
            alt="TinyClub"
            width={120}
            height={32}
          />
        </a>
      </header>

      {/* Centered login card */}
      <div className="flex justify-center" style={{ paddingTop: 104 }}>
        <div
          className="min-w-[360px] w-[360px] rounded-[32px] border border-border-tertiary bg-background p-8"
          style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}
        >
          <LoginCard error={error} />
        </div>
      </div>
    </div>
  );
}
